import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=705d7a1a&scoped=true&"
import script from "./Recruitment.vue?vue&type=script&lang=js&"
export * from "./Recruitment.vue?vue&type=script&lang=js&"
import style0 from "./Recruitment.vue?vue&type=style&index=0&id=705d7a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d7a1a",
  null
  
)

export default component.exports